module.exports = __webpack_public_path__ + "1bc4cf3c3f100a565bf4e280bf040b8f.jpg";